import { useEffect, useRef } from 'react';
import { LAYERS } from '../../Map/layers';
import { House3DTooltipsLayer } from './House3DTooltipsLayer';

const { buildingCenterCoordinates, tooltips } = window.params.houseTooltipsDetails;

export const useHouse3DTooltips = (map, selectedHouseIds, onShowHouseLayouts) => {
  const house3DTooltipsLayer = useRef(
    new House3DTooltipsLayer({
      origin: buildingCenterCoordinates,
      tooltips,
      selectedHouseIds,
      sectionsLayerId: LAYERS.sections,
      onShowHouseLayouts,
    }),
  ).current;

  useEffect(() => {
    house3DTooltipsLayer.setSelectedHouseIds(selectedHouseIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHouseIds]);

  useEffect(() => {
    if (!map) return;

    map.once('idle', () => {
      map.addLayer(house3DTooltipsLayer, LAYERS.sections);
    });
  }, [map, house3DTooltipsLayer]);
};
